import TemplateNames from './TemplateNames';

export default {
  title: 'Mensajes enviados',
  columns: {
    recipient: 'Destinatario',
    template: 'Plantilla',
    status: 'Estado',
    opened: 'Abierto',
    clicked: 'Clicado',
    sent_at: 'Enviado el',
  },
  labels: {
    empty_list: 'Aún no hay mensajes enviados',
    load_failed:
      'No se han podido cargar tus mensajes enviados. Recarga la página o ponte en contacto con el servicio de asistencia.',
    yes: 'Sí',
    no: 'No',
    clicked_at: 'Clicado el: {{date}}',
    opened_at: 'Abierto el: {{date}}',
  },
  message_statuses: {
    sent: 'Enviado',
    delivered: 'Entregado',
    failed: 'Fallido',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Error al cargar datos',
  },
};
